// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3f6c5a4d","977":"96e81e85"}[chunkId] + ".chunk.js";
};